import React, { memo } from 'react'
import { titleCase } from 'src/libs/qb-brand-web-components'
import { Card, Stack } from '@mui/material'

import { SOCIAL_MEDIA } from '../../constants/app'
import { LABEL_TEXT } from '../../constants/messages'
import CardHeading from '../text/CardHeading'
import CustomTextField from '../shared/inputs/CustomTextField'
import Button from '../shared/button/Button'
import { FacebookIcon, GoogleIcon } from '../../assets/icons/social-icons'

const DisplayEmailAddress = ({ email, signedUpVia, t }) => {
  return (
    <Card
      sx={{
        p: 3
      }}
    >
      <CardHeading
        title={t('user-account.logged-in-with', {
          provider: titleCase(signedUpVia)
        })}
      />
      <CustomTextField
        label={t('common.email-address')}
        value={email}
        disabled
      />
      <Stack spacing={3} sx={{ mt: 3, alignItems: 'flex-end' }}>
        <SocialMediaButton
          disabled
          type={signedUpVia}
          label={LABEL_TEXT.SIGNUP}
        />
      </Stack>
    </Card>
  )
}

export default memo(DisplayEmailAddress)

const SocialMediaButton = ({ type, label, disabled, ...restProps }) => {
  switch (type) {
    case SOCIAL_MEDIA.FACEBOOK:
      return (
        <Button
          disabled={disabled}
          label={
            <>
              <FacebookIcon width={22} sx={{ mr: 1 }} /> {label}
            </>
          }
        />
      )
    case SOCIAL_MEDIA.GOOGLE:
      return (
        <Button
          disabled={disabled}
          label={
            <>
              <GoogleIcon width={22} sx={{ mr: 1 }} /> {label}
            </>
          }
        />
      )
    default:
      return <Button {...restProps} />
  }
}
